export const TYPE_ERROR = "error";
export const TYPE_INFO = "info";
export const TYPE_SUCCESS = "success";
export const TYPE_WARNING = "warning";
